import React, { useEffect, useRef, useState } from 'react';
import { Container, RightContainer, Title, DescriptionInput, DescriptionText } from './styled.js';
import DescriptionIcon from '@mui/icons-material/TextSnippetOutlined';
import BottomButtonGroup from '../../../Pages/BoardPage/BoardComponents/BottomButtonGroup/BottomButtonGroup.js';
import { useDispatch, useSelector } from 'react-redux';
import { numeroSEIUpdateAbertura } from '../../../../Services/cardService.js';


const NumeroSEIAbertura = () => {

  const thisCard = useSelector((state) => state.card);
  
	const dispatch = useDispatch();
	const [inputFocus, setInputFocus] = useState(false);
	const [numSeiAberturas, setNumSeiAberturas] = useState(thisCard.numSeiAbertura);
	
	const ref = useRef();
	const ref2 = useRef();

	const handleSaveClick = async () => {
		setInputFocus(false);		
		await numeroSEIUpdateAbertura(thisCard.cardId, thisCard.listId, thisCard.boardId, numSeiAberturas, dispatch);
	};

	useEffect(() => {		
		setNumSeiAberturas(thisCard.numSeiAbertura);
	}, [thisCard.numSeiAbertura]);

	useEffect(() => {
		if (inputFocus) {
			ref.current.focus();
		}
	}, [inputFocus]);

	const handleClickOutside = (event) => {
		if (ref2.current && !ref2.current.contains(event.target)) {
			setInputFocus(false);
			setNumSeiAberturas(thisCard.numSeiAbertura);
		} else {
			setInputFocus(true);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});

	return (
		<Container ref={ref2}>
			<DescriptionIcon fontSize='small' />
			<RightContainer>
				<Title>SEI Abertura</Title>
				{numSeiAberturas && !inputFocus ? (
					<DescriptionText onClick={() => setInputFocus(true)}>{numSeiAberturas}</DescriptionText>
				) : (
					<DescriptionInput
						ref={ref}
						minHeight={inputFocus ? '5.5rem' : '2.5rem'}
						placeholder='Adicione Número SEI...'
						value={numSeiAberturas}
						onChange={(e) => setNumSeiAberturas(e.target.value)}
					/>
				)}
				<div style={{ display: inputFocus ? 'block' : 'none' }}>
					<BottomButtonGroup
						closeCallback={() => {
							setInputFocus(false);
							setNumSeiAberturas(thisCard.numSeiAbertura);
						}}
						clickCallback={handleSaveClick}
						title='Salvar'
					/>
				</div>
			</RightContainer>
		</Container>
	);
};

export default NumeroSEIAbertura;
